import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=2553db56&scoped=true&"
var script = {}
import style0 from "./banner.vue?vue&type=style&index=0&id=2553db56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2553db56",
  null
  
)

export default component.exports